import { asyncRoutes, constantRoutes } from '../../router/index'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some(role => route.meta.roles.includes(role))
//   } else {
//     return true
//   }
// }
function hasPermission(roles, route) {
    // let res = roles.includes(route.name)
    // console.log(res);
    return roles.includes(route.name);
}

/**     
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
    const res = []

    routes.forEach(route => {
        const tmp = {...route }
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles)
            }
            res.push(tmp)
        }
    })
    return res;
}

var permission = {
    // 项目仓库分支模块
    state: {
        routes: [],
        addRoutes: []
    },
    mutations: {
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes
            state.routes = constantRoutes.concat(routes)
        }
    },
    actions: {
        generateRoutes({ commit }, roles) {
            return new Promise(resolve => {
                let accessedRoutes;
                // if (roles.includes('admin')) {
                //   accessedRoutes = asyncRoutes || []
                // } else {
                accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
                    // }
                commit('SET_ROUTES', accessedRoutes)
                resolve(accessedRoutes)
            })
        }
    }
}
export default permission;